<template>
  <v-dialog v-model="showDialog" max-width="600">
    <v-card>
      <v-card-title class="secondary white--text">
        Commitment Logs
        <v-spacer />
        <v-btn icon @click="showDialog = false">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-timeline dense v-if="logs.length">
          <v-timeline-item v-for="log in logs" :key="log.id" small>
            <div><strong>{{ log.message }}</strong></div>
            <div class="caption grey--text">{{ log.updated_by }} — {{ log.created }}</div>
          </v-timeline-item>
        </v-timeline>
        <p v-else class="text-center grey--text mt-4">No logs found</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    value: Boolean,
    entryId: { type: Number, default: null },
  },
  data() {
    return { logs: [] };
  },
  computed: {
    showDialog: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); },
    },
  },
  watch: {
    value(val) {
      if (val && this.entryId) this.loadLogs();
    },
  },
  methods: {
    loadLogs() {
      this.$api.subHireCommitment
        .getSubHireCommitmentEntryLogs(this.entryId)
        .then((res) => { this.logs = res.data; })
        .catch(console.error);
    },
  },
};
</script>
